var map = {
	"./Framabag.vue": 115,
	"./Framabee.vue": 113,
	"./Framabin.vue": 116,
	"./Framaboard.vue": 117,
	"./Framabookin.vue": 118,
	"./Framacalc.vue": 119,
	"./Framaclic.vue": 120,
	"./Framadrive.vue": 121,
	"./Framadrop.vue": 122,
	"./Framaestro.vue": 123,
	"./Framalink.vue": 124,
	"./Framanews.vue": 125,
	"./Framanotes.vue": 126,
	"./Framapack.vue": 127,
	"./Framapiaf.vue": 128,
	"./Framapic.vue": 129,
	"./Framasite.vue": 130,
	"./Framaslides.vue": 131,
	"./Framasphere.vue": 132,
	"./Framastory.vue": 133,
	"./Framavectoriel.vue": 134,
	"./Framawiki.vue": 135,
	"./Framemo.vue": 136,
	"./Framindmap.vue": 137,
	"./Home.vue": 114,
	"./Mumble.vue": 138,
	"./Myframa.vue": 139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;